import React, { Component } from 'react';
import { string, func, oneOf, number, element, objectOf } from 'prop-types';

import cx from 'classnames';
import SuccessIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Cancel';
import Error from '@material-ui/icons/Error';
import InfoIcon from '../Icons/Information';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { isFunction } from 'lodash';

import {
    ERROR,
    INFO,
    SUCCESS,
    WARNING
  } from '../../helpers/constant';

import styles from './styles.scss';

const listColor = {
  [SUCCESS]: '#28BA3F',
  [ERROR]: '#FF0000',
  [INFO]: '#325491',
  [WARNING]: '#FFBB0A'
};

const listIcon = {
  [SUCCESS]: <SuccessIcon style={{ color: listColor[SUCCESS] }} />,
  [ERROR]: <ErrorIcon style={{ color: listColor[ERROR] }} />,
  [INFO]: <InfoIcon style={{ color: listColor[INFO] }} />,
  [WARNING]: <Error style={{ color: listColor[WARNING] }} />
};

export default class MessageWithStatus extends Component {
  static propTypes = {
    secondButtonLabel: string,
    firstButtonLabel: string,
    onFirstAction: func,
    onSecondAction: func,
    onClose: func,
    duration: number,
    type: oneOf([
      ERROR,
      INFO,
      SUCCESS,
    ]),
    label: string,
    customStyle: objectOf(string),
    description: element,
  };

  static defaultProps = {
    secondButtonLabel: 'See more detail',
    firstButtonLabel: 'Retry',
    duration: 0,
    type: '',
    label: '',
    description: '',
    customStyle: {},
  };

  
  render() {
    const {
      onClose,
      onFirstAction,
      onSecondAction,
      firstButtonLabel,
      secondButtonLabel,
      duration,
      type,
      label,
      description,
      customStyle
    } = this.props;

    const showCloseButton = isFunction(onClose);
    const showFirstActionButton = isFunction(onFirstAction);
    const showSecondActionButton = isFunction(onSecondAction);
    const showAction = showFirstActionButton || showSecondActionButton;

    return (
      <div
        className={cx(
          styles.toastContainer,
          { [styles.fade]: duration > 0 },
          customStyle.toastContainer
          )
        }
        style={{
          animationDelay: `${duration}s`,
        }}
      >
        <div className={cx(styles.borderLeft, styles[type.toLowerCase()])} />
        <div className={cx(styles.toastContent, customStyle.toastContent)}>
          {type && (
            <div className={cx(styles.typeIcon, customStyle.typeIcon)}>
              {listIcon[type]}
            </div>
          )}
          <div
            className={styles.contentText}
            data-test="statusMsg"
          >
            {label && <span className={styles.typeText} data-test="statusLabel">{label}: </span>}
            {description}
            {showAction && (
              <React.Fragment>
                <br />
                {showFirstActionButton && (
                  <span className={styles.actionButton} onClick={onFirstAction}>
                    {firstButtonLabel}
                  </span>
                )}
                {showSecondActionButton && (
                  <span
                    className={cx(styles.actionButton, {
                      [styles.showDetailButton]: showFirstActionButton
                    })}
                    onClick={onSecondAction}
                  >
                    {secondButtonLabel}
                  </span>
                )}
              </React.Fragment>
            )}
          </div>
          {showCloseButton && (
            <IconButton onClick={onClose} classes={{ root: styles.closeButton}}>
              <CloseIcon classes={{ root: styles.actionIcon }} />
            </IconButton>
          )}
        </div>
      </div>
    );
  }
}
